/**
 * Shared reset MFA API and toast feedback.
 * Call from Admin or Members actions; pass the toast container ID for the current page.
 */
import { ToastType } from '@alefeducation/ui-elements-library-core';
import { MFA_RESET_FAILED, MFA_RESET_SUCCESS } from './constants';
import { fetchApiPost } from './fetchUtils';
import { injectAutoHideToastOfType } from './Toast';

const RESET_MFA_PATH = '/shared-iam-service/api/users/reset-mfa';

export async function resetMFA(
  userId: string,
  toastContainerId: string,
): Promise<void> {
  try {
    const response = await fetchApiPost(RESET_MFA_PATH, [userId]);
    if (!response.ok) {
      injectAutoHideToastOfType(
        toastContainerId,
        MFA_RESET_FAILED,
        ToastType.ERROR,
      );
      return;
    }
    const data = (await response.json()) as { passed?: string[] };
    if (data?.passed && data.passed.length > 0) {
      injectAutoHideToastOfType(
        toastContainerId,
        MFA_RESET_SUCCESS,
        ToastType.SUCCESS,
      );
    } else {
      injectAutoHideToastOfType(
        toastContainerId,
        MFA_RESET_FAILED,
        ToastType.ERROR,
      );
    }
  } catch {
    injectAutoHideToastOfType(
      toastContainerId,
      MFA_RESET_FAILED,
      ToastType.ERROR,
    );
  }
}
